import React, { useState, useEffect } from "react";
import PaymentButton from "../Payment/PaymentButton";
import { useNavigate, Link } from "react-router-dom";
import "./CartPage.css";

export default function CartPage() {
  const navigate = useNavigate();
  const [cartItems, setCartItems] = useState([]);
  const [reservedCourses, setReservedCourses] = useState([]);
  const [signedUpCourses, setSignedUpCourses] = useState([]);

  const [remainingCourses, setRemainingCourses] = useState([]);

  const [gstNumber, setGstNumber] = useState("");
  // const [showGST, setShowGST] = useState(false);
  // const [loading, setLoading] = useState(false);
  const [profile, setProfile] = useState(null);

  // const [userCountry, setUserCountry] = useState("India");

  // const formatPrice = (amount, currency = "INR") => {  #Remove part
  //   const validAmount = typeof amount === "number" ? amount : 0;
  //   return validAmount.toLocaleString(undefined, {
  //     style: "currency",
  //     currency: currency === "INR" ? "INR" : "USD",
  //     minimumFractionDigits: 2,
  //     maximumFractionDigits: 2,
  //   });
  // };

  const formatPrice = (amount) => {
    const validAmount = typeof amount === "number" ? amount : 0;
    return validAmount.toLocaleString(undefined, {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    });
  };
  const fetchCart = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (!user?.uid) return;

      const res = await fetch(
        `https://agepcoatings.com/payments/getcart/${user.uid}`,
      );
      const data = await res.json();
      if (data.success && Array.isArray(data.items)) {
        const normalizedCart = data.items.map((item) => {
          const fullAmount = Number(item.fullAmount || item.amount || 0);
          const paidAmount = Number(
            item.paidAmount ||
              (item.mode === "partial" ? fullAmount * 0.25 : fullAmount),
          );
          const remainAmount =
            item.remainAmount !== undefined
              ? Number(item.remainAmount)
              : fullAmount - paidAmount;
          const amountToPay =
            item.mode === "partial"
              ? fullAmount * 0.25
              : item.mode === "remaining"
                ? remainAmount
                : fullAmount;

          return { ...item, fullAmount, paidAmount, remainAmount, amountToPay };
        });
        setCartItems(normalizedCart);
        localStorage.setItem("cart", JSON.stringify(normalizedCart));
      }
    } catch (err) {
      console.error("Error fetching cart:", err);
    }
  };

  const fetchProfile = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (!user?.email) return;

      const res = await fetch(
        `https://agepcoatings.com/getuserbyemail/${encodeURIComponent(user.email)}`,
      );
      const data = await res.json();
      if (data.success && data.data) {
        setProfile(data.data);
        // const gstNo = data.data.gstNo || "";
        // setGstNumber(gstNo);
        // if (gstNo) setShowGST(true);
        // if (data.data.country) setUserCountry(data.data.country);
        const gstNo = data.data.gstNo || "";
        setGstNumber(gstNo);
      }
    } catch (err) {
      console.error("Error fetching profile:", err);
    }
  };

  useEffect(() => {
    fetchCart();
    fetchProfile();
  }, []);

  useEffect(() => {
    setReservedCourses(cartItems.filter((item) => item.mode === "partial"));
    setSignedUpCourses(cartItems.filter((item) => item.mode === "full"));
    setRemainingCourses(cartItems.filter((item) => item.mode === "remaining"));
  }, [cartItems]);

  const handleRemove = async (courseId, levelId) => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      if (!user?.uid) return;
      await fetch("https://agepcoatings.com/payments/removecart", {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ uid: user.uid, courseId, levelId }),
      });
      fetchCart();
    } catch (err) {
      console.error(err);
    }
  };

  // const handleGSTUpdate = async () => {
  //   const user = JSON.parse(localStorage.getItem("user"));
  //   if (!user?.email) return;
  //   try {
  //     setLoading(true);
  //     await fetch(`https://agepcoatings.com/courseUser/${user.email}`, {
  //       method: "PUT",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({ gstNo: gstNumber }),
  //     });
  //   } catch (err) {
  //     console.error(err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleProfileChange = (field, value) =>
    setProfile((prev) => ({ ...prev, [field]: value }));

  const handleProfileBlur = async (field) => {
    if (!profile?.email) return;
    try {
      await fetch(`https://agepcoatings.com/courseUser/${profile.email}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ [field]: profile[field] }),
      });
    } catch (err) {
      console.error(err);
    }
  };

  const addSerial = (arr) =>
    arr.map((item, idx) => ({ ...item, serial: idx + 1 }));
  const signedUpWithSerial = addSerial(signedUpCourses);
  const reservedWithSerial = addSerial(reservedCourses);
  const remainingWithSerial = addSerial(remainingCourses);

  // const isIndia = userCountry?.toLowerCase() === "india";
  // const subtotal = cartItems.reduce(
  //   (sum, item) => sum + (item.amountToPay || 0),
  //   0
  // );
  // const gstAmount = isIndia && showGST && gstNumber ? subtotal * 0.18 : 0;
  // const totalForPayment = subtotal + gstAmount;
  // const currencySymbol = isIndia ? "₹" : "$";

  // const isIndia = userCountry?.toLowerCase() === "india"; #Remove Part

  const subtotal = cartItems.reduce(
    (sum, item) => sum + (item.amountToPay || 0),
    0,
  );

  // ✅ Always apply GST if India, number or not
  // const gstAmount = isIndia ? subtotal * 0.18 : 0; #Remove Part

  // const totalForPayment = subtotal + gstAmount; #Remove Part

  const gstAmount = 0;

  const totalForPayment = subtotal;
  // const currency = isIndia ? "INR" : "USD"; #Remove Part

  const currency = "USD";

  // alert message if cart empty
  // const isCartEmpty = !subtotal || totalForPayment <= 0;

  return (
    <div className="container cart-container">
      <div className="cart-left">
        <Link className="btn custom-back-btn mb-4" onClick={() => navigate(-1)}>
          ← Back
        </Link>
        <h3 className="mb-mb-5 my-cart">My Cart</h3>

        {signedUpWithSerial.length > 0 && (
          <div className="cart-box">
            <h2>Enrolling For</h2>
            {signedUpWithSerial.map((item) => (
              <div key={item.levelId} className="cart-item">
                <div className="cart-info">
                  <h4>
                    {item.serial}. {item.courseTitle}
                  </h4>
                  <p>{item.levelName}</p>
                  <p>{item.levelbadge}</p>
                </div>
                <div className="cart-price">
                  {formatPrice(item.amountToPay, currency)}
                </div>
                <button
                  className="cart-remove"
                  onClick={() => handleRemove(item.courseId, item.levelId)}
                >
                  🗑
                </button>
              </div>
            ))}
          </div>
        )}

        {reservedWithSerial.length > 0 && (
          <div className="cart-box">
            <h2>
              Reserving For{" "}
              <span className="text-muted reserve-text-pay">
                *Reserve seat with 25%, pay remaining before course starts.
              </span>
            </h2>
            {reservedWithSerial.map((item) => {
              const paid = item.paidAmount;
              const remaining = item.remainAmount;
              return (
                <div key={item.levelId} className="cart-item reserved">
                  <div className="cart-info">
                    <h4>
                      {item.serial}. {item.courseTitle}
                    </h4>
                    <p>{item.levelName}</p>
                    <p>{item.levelbadge}</p>
                    <small>
                      Total: {formatPrice(item.fullAmount, currency)} | Balance
                      Due: {formatPrice(remaining, currency)}
                    </small>
                  </div>
                  <div className="cart-price remaining">
                    {formatPrice(paid, currency)}
                  </div>
                  <button
                    className="cart-remove"
                    onClick={() => handleRemove(item.courseId, item.levelId)}
                  >
                    🗑
                  </button>
                </div>
              );
            })}
          </div>
        )}

        {remainingWithSerial.length > 0 && (
          <div className="cart-box">
            <h2>Course Enrollment</h2>
            {remainingWithSerial.map((item) => (
              <div key={item.levelId} className="cart-item remaining">
                <div className="cart-info">
                  <h4>
                    {item.serial}. {item.courseTitle}
                  </h4>
                  <p>{item.levelName}</p>
                  <p>{item.levelbadge}</p>
                  {/* <small>
                    Total: {formatPrice(item.fullAmount, item.currency)}
                  </small> */}
                </div>
                <div className="cart-price remaining">
                  {formatPrice(item.fullAmount, currency)}
                </div>
                <button
                  className="cart-remove"
                  onClick={() => handleRemove(item.courseId, item.levelId)}
                >
                  🗑
                </button>
              </div>
            ))}
          </div>
        )}

        {/* Terms & Policy */}
        <div className="policy-box">
          <h3>Transfer & Cancellation Policy *</h3>
          <h4>AMPP/AGEP-Cancelled or Rescheduled Courses</h4>
          <ul>
            <li>
              AMPP & AGEP reserves the right to cancel or reschedule any course
              at any time.
            </li>
            <li>
              Effort to confirm courses at least 21 days before start date.
            </li>
            <li>
              If AMPP/AGEP cancels a course:
              <ul>
                <li>Full refund of course fees, or</li>
                <li>Apply payment toward a future course.</li>
              </ul>
            </li>
            <li>
              One year from cancellation to enroll in another course; unused
              funds after that are forfeited.
            </li>
            <li>
              Not responsible for travel/lodging expenses due to rescheduling.
            </li>
          </ul>

          <h4>Student-Initiated Cancellations & Transfers</h4>
          <ul>
            <li>Notify AGEP via email/phone to cancel/transfer.</li>
            <li>One transfer per registration. Non-refundable.</li>
          </ul>

          <h4>Refund & Transfer Policy Based on Notice Given:</h4>
          <ul>
            <li>
              35+ days: 100% refund minus $250 fee or full credit minus $250
              transfer fee.
            </li>
            <li>
              34-15 days: 50% refund or full credit minus $250 transfer fee.
            </li>
            <li>14 or fewer days: No refund/transfer.</li>
          </ul>

          <h4>Additional Policies</h4>
          <ul>
            <li>Student Replacement: $250 service fee.</li>
            <li>Virtual/Online/e-Courses: Non-refundable.</li>
            <li>Exam-Only Fees: Non-refundable.</li>
            <li>Extenuating circumstances exceptions at AMPP discretion.</li>
          </ul>

          <p className="policy-note">
            * See registration confirmation email for full policy details.
            <br />
            ** Register at least 30 days in advance to reduce class cancellation
            risk.
          </p>
        </div>
      </div>

      <div className="cart-right">
        <div className="summary-box">
          <h3>Order Summary</h3>
          <p>{cartItems.length} Items</p>
          <hr />
          {/* {isIndia && (
            <div className="gst-section">
              <label>GST Number</label>
              <input
                type="text"
                value={gstNumber}
                onChange={(e) => setGstNumber(e.target.value)}
                onBlur={handleGSTUpdate} // only saves number if entered
                placeholder="Enter GST Number"
              />
              {loading && <p className="loading-text">Updating...</p>}
            </div>
          )} */}

          {/* {isIndia && (
            <div className="gst-section">
              <label>
                <input
                  type="checkbox"
                  checked={showGST}
                  onChange={(e) => setShowGST(e.target.checked)}
                />
                Apply GST Number
              </label>
              {showGST && (
                <input
                  type="text"
                  value={gstNumber}
                  onChange={(e) => setGstNumber(e.target.value)}
                  onBlur={handleGSTUpdate}
                  placeholder="Enter GST Number"
                />
              )}
              {loading && <p className="loading-text">Updating...</p>}
            </div>
          )} */}

          <div className="summary-details">
            <div className="summary-row">
              <span>Subtotal</span>
              <span>
                {/* {formatPrice(subtotal, isIndia ? "INR" : "USD")} */}
                {formatPrice(subtotal)}
              </span>
            </div>
            {/* {isIndia && (
              <div className="summary-row">
                <span>GST (18%)</span>
                <span>{formatPrice(gstAmount, isIndia ? "INR" : "USD")}</span>
              </div>
            )} */}
            <hr />
            <div className="summary-row total">
              <span>Total</span>
              <span>
                {/* {formatPrice(totalForPayment, isIndia ? "INR" : "USD")} */}
                {formatPrice(totalForPayment)}
              </span>
            </div>
            {/* {isCartEmpty && (
              <div
                className="alert-message"
                style={{ color: "red", marginTop: "10px" }}
              >
                Your cart is empty
              </div>
            )} */}
          </div>

          <PaymentButton
            cartItems={cartItems}
            totalForPayment={totalForPayment}
            currencySymbol={currency}
            gstNumber={gstNumber}
            // gstApplied={isIndia && showGST}
            gstApplied={false}
            gstAmount={gstAmount}
            billingDetails={{
              fullname: profile?.firstName || "",
              address: profile?.fullAddress || "",
              isMember: profile?.isMember || "no",
              memberNumber: profile?.memberNumber || "",
            }}
          />
        </div>

        {/* Billing Section */}
        {profile && (
          <div className="billing-box">
            <h3>Billing Details</h3>
            <hr />
            <div className="billing-field">
              <label>FullName</label>
              <input
                type="text"
                value={profile.firstName}
                onChange={(e) =>
                  handleProfileChange("firstName", e.target.value)
                }
                onBlur={() => handleProfileBlur("firstName")}
              />
            </div>
            <div className="billing-field">
              <label>Country</label>
              <input type="text" value={profile.country || ""} disabled />
            </div>
            <div className="billing-field">
              <label>City</label>
              <input
                type="text"
                value={profile.city}
                onChange={(e) => handleProfileChange("city", e.target.value)}
                onBlur={() => handleProfileBlur("city")}
              />
            </div>
            {profile.isMember === "yes" && (
              <>
                <div className="billing-field">
                  <label>Ampp Member</label>
                  <input
                    type="text"
                    value={profile.isMember}
                    onChange={(e) =>
                      handleProfileChange("isMember", e.target.value)
                    }
                    onBlur={() => handleProfileBlur("isMember")}
                  />
                </div>
                <div className="billing-field">
                  <label>Ampp Member ID</label>
                  <input
                    type="text"
                    value={profile.memberNumber}
                    onChange={(e) =>
                      handleProfileChange("memberNumber", e.target.value)
                    }
                    onBlur={() => handleProfileBlur("memberNumber")}
                  />
                </div>
              </>
            )}
            <div className="billing-field">
              <label>Address</label>
              <input
                type="text"
                value={profile.fullAddress}
                onChange={(e) =>
                  handleProfileChange("fullAddress", e.target.value)
                }
                onBlur={() => handleProfileBlur("fullAddress")}
              />
            </div>
            <div className="billing-field">
              <label>Postal Code</label>
              <input
                type="text"
                value={profile.postalCode}
                onChange={(e) =>
                  handleProfileChange("postalCode", e.target.value)
                }
                onBlur={() => handleProfileBlur("postalCode")}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
